import styled from "@mui/material/styles/styled";

import ScrollSlider from "@app/analytics/components/ScrollSlider";

import Stack, { StackProps } from "@rui/Stack";

import Moment from "./Moment";
import { Moment as MomentType } from "./types";

const VerticalContainer = styled((props: StackProps) => (
  <Stack spacing={1} {...props} />
))({});

const Moments = ({
  moments,
  onClickMoment,
  orientation = "horizontal",
}: {
  moments: MomentType[];
  onClickMoment: (m: MomentType) => (() => void) | undefined;
  orientation?: "horizontal" | "vertical";
}) => {
  const Container =
    orientation === "horizontal" ? ScrollSlider : VerticalContainer;

  return (
    <Container>
      {moments.map((moment) => (
        <Moment
          {...moment}
          key={moment.id}
          onClick={onClickMoment(moment)}
          orientation={orientation}
        />
      ))}
    </Container>
  );
};

export default Moments;
